import { MutableValue } from "@/modules/api/mutable-value.interface";

import { ProductAllocationSlotTypeValue } from "./product-allication-slot-type.value";

export default class FactoryPhaseSupport implements MutableValue {
  public isNew = true;

  private fCreatedAt?: Date;
  private fUpdatedAt?: Date;

  constructor(
    private fId: string,
    private fFactory: string,
    private fSlotType: ProductAllocationSlotTypeValue
  ) {
    [fId, fFactory, fSlotType].forEach((arg, index) => {
      if (arg === undefined) {
        throw new Error(`Undefined value passed at position: ${index}`);
      }
    });
  }

  get id(): string {
    return this.fId;
  }

  get factory(): string {
    return this.fFactory;
  }

  get slotType(): ProductAllocationSlotTypeValue {
    return this.fSlotType;
  }

  get createdAt(): Date | undefined {
    return this.fCreatedAt;
  }

  get updatedAt(): Date | undefined {
    return this.fUpdatedAt;
  }
}
